import * as React from 'react';
import { ManualAccess } from '../../../../../../api/PropertyIntegration';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import Checkbox from '../../../../../common/form/Checkbox';
import ManualAccessStatusDisplay from './ManualAccessStatusDisplay';

interface Props {
    code: ManualAccess;
    selected: boolean;
    onClickCode: (codeId: number) => void;
}

const ManualAccessRow = (props: Props) => {
    return (
        <Row className="code-row">
            <Col md={1}>
                <span className="code-display">
                    <Checkbox
                        inputProps={{
                            id: `cb-code-${props.code.id}`,
                            checked: props.selected,
                            name: `cbCode${props.code.id}`
                        }}
                        onChange={() => props.onClickCode(props.code.id)}
                        styledCheckbox={true}
                    />
                </span>
            </Col>
            <Col md={6}>
                <span className="code-display">{props.code.code}</span>
            </Col>
            <Col md={4}>
                <ManualAccessStatusDisplay status={props.code.codeStatus} />
            </Col>
        </Row>
    );
};
export default ManualAccessRow;



// WEBPACK FOOTER //
// ./src/components/pages/admin/editProperty/integrationControls/manualAccessControls/ManualAccessRow.tsx